
import React, { useState, useEffect, useCallback } from "react";
import PropTypes from 'prop-types'
import { Link as RouterLink, useHistory } from "react-router-dom";
import { logout, logoutNow } from "../../redux/user/userActions"
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
//MUI imports
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Drawer from '@material-ui/core/Drawer'
import Link from '@material-ui/core/Link'
import MenuItem from '@material-ui/core/MenuItem'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Popper from '@material-ui/core/Popper'
import MenuList from '@material-ui/core/MenuList'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Box from "@material-ui/core/Box"
import Avatar from '@material-ui/core/Avatar'
//Icons
import BookmarksIcon from '@material-ui/icons/Bookmarks'
import LocalMallIcon from '@material-ui/icons/LocalMall'
import PersonIcon from '@material-ui/icons/Person'
import HomeIcon from '@material-ui/icons/Home'
import ListAltIcon from '@material-ui/icons/ListAlt'
import MenuBookIcon from '@material-ui/icons/MenuBook'
import InfoIcon from '@material-ui/icons/Info'
import PhoneIcon from '@material-ui/icons/Phone'
import MenuIcon from "@material-ui/icons/Menu";
import GTranslateIcon from '@material-ui/icons/GTranslate'
import PermIdentityIcon from '@material-ui/icons/PermIdentity'
//My Components
import LoginModal from "../LoginModal/Index";
import * as TextLoader from '../../components/StaticTexts/Index'

const useStyles = makeStyles((theme) => ({
    headerMobile: {
        backgroundColor: 'transparent',
        backgroundImage: 'url(/images/home-page-header/phone-top-bg.png)',
        paddingRight: '0px',
        paddingTop: '0px',
        marginTop: '0px',
        paddingLeft: '0px',
        marginLeft: '0px',
        direction: 'rtl',
        minHeight: '123px',
    },
    headerDesktop: {
        backgroundImage: 'url(/images/home-page-header/header-bg.jpg)',
        paddingRight: '0px',
        marginTop: '0px',
        paddingTop: '0px',
        paddingLeft: '0px',
        backgroundColor: 'transparent',
        direction: 'rtl',
        minHeight: '293px',
    },
    radio: {
        '&$checked': {
            color: '#28A504'
        }
    },
    logo: {
        fontFamily: "Dana-FaNum",
        fontWeight: 600,
        color: "#FFFEFE",
        textAlign: "left",
    },
    menuButton: {
        fontFamily: "Dana-FaNum",
        fontWeight: 700,
        fontSize: "17px",
        marginLeft: "15px",
        [theme.breakpoints.up("md")]: {
            fontSize: "17px !important"
        },
        [theme.breakpoints.down("md")]: {
            fontSize: "15px !important"
        }
    },
    drawerPaper: {
        backgroundColor: '#950000'
    },
    drawerContainer: {
        width: '280px',
        textAlign: 'right'
    },
    menuItem: {
        fontFamily: "Dana-FaNum",
    },
    base: {
        flexGrow: 1,
    },
    container: {
        [theme.breakpoints.up("lg")]: {
            width: 1534
        }
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: 'transparent !important',
        border: 'none !important',
        boxShadow: 'none'
    },
}));

const Header = ({ lang, }) => {
    const dispatch = useDispatch()
    const history = useHistory();
    const [staticText, setStaticText] = useState({});
    const [headersData, setHeadersData] = useState([]);
    const { header, base, container, headerMobile, headerDesktop, menuItem, paper, menuButton, toolbar, drawerContainer, drawerPaper } = useStyles();
    const [menuBg, setMenuBg] = useState('/images/home-page-header/header-bg.jpg');
    const [open, setOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const anchorRef2 = React.useRef(null);
    const anchorRef = React.useRef(null);
    const [userData, setUserData] = useState([]);

    const userLogin = useSelector((state) => state.userLogin)
    const { userInfo } = userLogin

    const { reduxCartItems } = useSelector((state) => state.cart);

    const setStateCallback = useCallback((state) => {
        setUserData(state);
    }, []);

    const handleToggle2 = () => {
        setOpen2((prevOpen2) => !prevOpen2);
    };

    const handleClose2 = (event) => {
        if (anchorRef2.current && anchorRef2.current.contains(event.target)) {
            return;
        }

        setOpen2(false);
    };

    function handleListKeyDown2(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen2(false);
        }
    }

    const prevOpen2 = React.useRef(open2);
    React.useEffect(() => {
        if (prevOpen2.current === true && open === false) {
            anchorRef2.current.focus();
        }

        prevOpen2.current = open2;
    }, [open2]);

    const handleDispatch = (event) => {
        if (anchorRef2.current && anchorRef2.current.contains(event.target)) {
            return;
        }
        setOpen2(false);
        dispatch(logout())
    }

    useEffect(() => {
        if (localStorage.getItem("token")) {
            const fetchData = async () => {
                const config = {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem("token"),
                        "Content-Type": "application/json",
                    },
                };
                try {
                    const response = await axios.get('/api/accounts/profile', config);

                    const data = await response.data;

                    if (data.status === "ok") {
                        setStateCallback(data);
                    } else {
                        dispatch(logoutNow())
                    }
                } catch (error) {
                    if (error.response.status === 401) {
                        dispatch(logoutNow())
                    }
                }
            };
            fetchData();
        }
    }, [setStateCallback]);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const openModal = () => {
        setIsModalOpen(true);
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    const changeLang = (targetLang) => {
        if (targetLang === "fa") {
            if (history.location.pathname.includes("/products") || history.location.pathname.includes("/articels") || history.location.pathname.includes("/product") || history.location.pathname.includes("/article"))
                localStorage.setItem('lang', targetLang);
            else {
                localStorage.setItem('lang', targetLang);
                history.push(history.location.pathname.replace("/ar/", ""))
            }
            window.location.reload(false);
        }
        else {
            if (history.location.pathname.includes("/products") || history.location.pathname.includes("/articels") || history.location.pathname.includes("/product") || history.location.pathname.includes("/article"))
                localStorage.setItem('lang', targetLang);
            else {
                localStorage.setItem('lang', targetLang);
                history.push("/" + targetLang + history.location.pathname)
            }
            window.location.reload(false);
        }
    }

    const changeToFa = (event) => {
        changeLang('fa')
    };

    const changeToAr = (event) => {
        changeLang('ar')
    };

    const [state, setState] = useState({
        mobileView: false,
        drawerOpen: false,
    });

    const { mobileView, drawerOpen } = state;

    useEffect(() => {
        const setResponsiveness = () => {
            return window.innerWidth < 900
                ? setState((prevState) => ({ ...prevState, mobileView: true }))
                : setState((prevState) => ({ ...prevState, mobileView: false }));
        };
        window.addEventListener("resize", () => setResponsiveness())
        setResponsiveness();
        setStaticText(TextLoader.staticTextLoader("header", lang))
        setHeadersData(TextLoader.staticTextLoader("menu", lang))
    }, [open]);

    const handleRadioChange = (event) => {
        // if (event.target.value === "ar" && localStorage.getItem("lang") !== "ar") {
        //     changeLang('ar')
        // }
        // else {
        //     changeLang('fa')
        // }
    };

    const displayDesktop = () => {
        return (
            <AppBar position={'static'} className={headerDesktop + ' normal'}>
                <Toolbar className={toolbar}>
                    <Grid container justify="center" className={base}>
                        <Grid justify="center" className={container} container spacing={0}>
                            <Grid item md={7}>
                                <Paper style={{ textAlign: 'right', color: '#ffffff' }} alignItems="right" className={paper}>
                                    <Box evelation={0} md={1}>
                                        <div>
                                            {getMenuButtons()}
                                        </div>
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item md={5}>
                                <Paper className={paper}>
                                    <Box evelation={0}>

                                        <div className="displayTable" style={{ width: '70%', float: 'left' }}>
                                            <div className="cell vertical-middle text-left">
                                                <Button
                                                    ref={anchorRef}
                                                    aria-controls={open ? 'menu-list-grow' : undefined}
                                                    aria-haspopup="true"
                                                    onClick={handleToggle}>
                                                    <GTranslateIcon style={{ fill: '#fff' }} />
                                                </Button>
                                                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                                                    {({ TransitionProps, placement }) => (
                                                        <Grow
                                                            {...TransitionProps}
                                                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                                        >
                                                            <Paper>
                                                                <ClickAwayListener onClickAway={handleClose}>
                                                                    <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                                        <MenuItem className={menuItem}>فارسی</MenuItem>
                                                                        <MenuItem className={menuItem}>عربی</MenuItem>
                                                                    </MenuList>
                                                                </ClickAwayListener>
                                                            </Paper>
                                                        </Grow>
                                                    )}
                                                </Popper>
                                            </div>
                                            <div className="cell vertical-middle text-left">
                                                {userData.length === 0 ? (
                                                    <span className="shopping-bag cur-pointer"><RouterLink onClick={openModal}><BookmarksIcon /></RouterLink></span>
                                                ) : (
                                                    <span className="shopping-bag cur-pointer"><RouterLink to="/profile/bookmarks"><BookmarksIcon /></RouterLink></span>
                                                )}
                                            </div>
                                            <div className="cell vertical-middle text-left">
                                                <span className="shopping-bag cur-pointer"><RouterLink to="/cart"><LocalMallIcon /><span className="iib">{reduxCartItems.length}</span></RouterLink></span>
                                            </div>
                                            <div className="cell vertical-middle">
                                                {userData.length === 0 ? (
                                                    <>
                                                        {userInfo && (
                                                            <>
                                                                {userInfo.status !== "error" && (
                                                                    <>
                                                                        {userInfo.length !== 0 && (
                                                                            <>
                                                                                <Button
                                                                                    className="account-btn"
                                                                                    onClick={handleToggle2}
                                                                                    variant="danger"
                                                                                    ref={anchorRef2}
                                                                                    style={{
                                                                                        padding: "5px 8px 5px 8px",
                                                                                        width: "100%",
                                                                                        textAlign: "center",
                                                                                    }}
                                                                                    aria-controls={
                                                                                        open2 ? "menu-list-grow" : undefined
                                                                                    }
                                                                                    aria-haspopup="true"
                                                                                >
                                                                                    <PermIdentityIcon
                                                                                        style={{ fill: "#fff" }}
                                                                                    />

                                                                                    <span
                                                                                        style={{
                                                                                            display: "inline-block",
                                                                                            marginRight: "7px",
                                                                                        }}
                                                                                    >
                                                                                        {userInfo.fullName}
                                                                                    </span>
                                                                                </Button>
                                                                                <Popper
                                                                                    open={open2}
                                                                                    anchorEl={anchorRef2.current}
                                                                                    role={undefined}
                                                                                    transition
                                                                                    disablePortal
                                                                                >
                                                                                    {({ TransitionProps, placement }) => (
                                                                                        <Grow
                                                                                            {...TransitionProps}
                                                                                            style={{
                                                                                                transformOrigin:
                                                                                                    placement === "bottom"
                                                                                                        ? "center top"
                                                                                                        : "center bottom",
                                                                                            }}
                                                                                        >
                                                                                            <Paper>
                                                                                                <ClickAwayListener
                                                                                                    onClickAway={handleClose2}
                                                                                                >
                                                                                                    <MenuList
                                                                                                        autoFocusItem={open2}
                                                                                                        id="menu-list-grow"
                                                                                                        onKeyDown={handleListKeyDown2}
                                                                                                    >
                                                                                                        <MenuItem
                                                                                                            onClick={handleClose2}
                                                                                                        >
                                                                                                            <RouterLink
                                                                                                                to="/profile"
                                                                                                                style={{
                                                                                                                    fontSize: "0.920rem",
                                                                                                                }}
                                                                                                            >
                                                                                                                ویرایش اطلاعات کاربری
                                                    </RouterLink>
                                                                                                        </MenuItem>
                                                                                                        <MenuItem
                                                                                                            style={{
                                                                                                                fontSize: "0.920rem",
                                                                                                            }}
                                                                                                            onClick={handleDispatch}
                                                                                                        >
                                                                                                            خروج
                                                  </MenuItem>
                                                                                                    </MenuList>
                                                                                                </ClickAwayListener>
                                                                                            </Paper>
                                                                                        </Grow>
                                                                                    )}
                                                                                </Popper>
                                                                            </>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                        {!userInfo && (
                                                            <Button
                                                                className="account-btn"
                                                                onClick={openModal}
                                                                variant="danger"
                                                            >
                                                                <PersonIcon /> {staticText.accountBtn}{" "}
                                                            </Button>
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        <Button
                                                            className="account-btn"
                                                            onClick={handleToggle2}
                                                            variant="danger"
                                                            ref={anchorRef2}
                                                            style={{
                                                                padding: "5px 8px 5px 8px",
                                                                width: "100%",
                                                                textAlign: "center",
                                                            }}
                                                            aria-controls={open2 ? "menu-list-grow" : undefined}
                                                            aria-haspopup="true"
                                                        >
                                                            {userData.data.imageURL ? (
                                                                <img
                                                                    src={userData.data.imageURL}
                                                                    width="24px"
                                                                    height="24px"
                                                                    style={{ borderRadius: "50%" }}
                                                                />
                                                            ) : (
                                                                <PermIdentityIcon style={{ fill: "#fff" }} />
                                                            )}
                                                            <span
                                                                style={{
                                                                    display: "inline-block",
                                                                    marginRight: "7px",
                                                                }}
                                                            >
                                                                {userData.data.fullName}
                                                            </span>
                                                        </Button>
                                                        <Popper
                                                            open={open2}
                                                            anchorEl={anchorRef2.current}
                                                            role={undefined}
                                                            transition
                                                            disablePortal
                                                        >
                                                            {({ TransitionProps, placement }) => (
                                                                <Grow
                                                                    {...TransitionProps}
                                                                    style={{
                                                                        transformOrigin:
                                                                            placement === "bottom"
                                                                                ? "center top"
                                                                                : "center bottom",
                                                                    }}
                                                                >
                                                                    <Paper>
                                                                        <ClickAwayListener onClickAway={handleClose2}>
                                                                            <MenuList
                                                                                autoFocusItem={open2}
                                                                                id="menu-list-grow"
                                                                                onKeyDown={handleListKeyDown2}
                                                                            >
                                                                                <MenuItem onClick={handleClose2}>
                                                                                    <RouterLink
                                                                                        to="/profile"
                                                                                        style={{ fontSize: "0.920rem" }}
                                                                                    >
                                                                                        ویرایش اطلاعات کاربری
                                        </RouterLink>
                                                                                </MenuItem>
                                                                                <MenuItem
                                                                                    style={{ fontSize: "0.920rem" }}
                                                                                    onClick={handleDispatch}
                                                                                >
                                                                                    خروج
                                      </MenuItem>
                                                                            </MenuList>
                                                                        </ClickAwayListener>
                                                                    </Paper>
                                                                </Grow>
                                                            )}
                                                        </Popper>
                                                    </>
                                                )}
                                            </div>    </div>

                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar >
            </AppBar >
        );
    };

    const displayMobile = () => {
        const handleDrawerOpen = () =>
            setState((prevState) => ({ ...prevState, drawerOpen: true }));
        const handleDrawerClose = () =>
            setState((prevState) => ({ ...prevState, drawerOpen: false }));

        return (
            <AppBar position={'sticky'} className={headerMobile + ' normal'}>
                <Toolbar>
                    <div className="displayTable" style={{ width: '100%', marginTop: '6px', float: 'left' }}>
                        <div className="cell vertical-middle text-center" style={{ width: '20%', textAlign: 'center' }}>
                            <IconButton
                                style={{ paddingTop: '14px', marginTop: '5px' }}
                                {...{
                                    edge: "start",
                                    color: "inherit",
                                    "aria-label": "menu",
                                    "aria-haspopup": "true",
                                    onClick: handleDrawerOpen,
                                }}>
                                <MenuIcon className="menuToggleBtn" />
                            </IconButton>
                        </div>
                        <div className="cell vertical-middle">
                            <RouterLink to="/cart" style={{ marginRight: '8px' }}><LocalMallIcon style={{ marginTop: '10px', width: '1.3em', height: '1.3em', color: '#fff' }} /><span className="iib">{reduxCartItems.length}</span></RouterLink>
                        </div>
                        <div className="cell vertical-middle text-left" style={{ width: '20%' }}>
                            {userData.length === 0 ? (
                                <RouterLink onClick={openModal}><BookmarksIcon style={{ width: '1.3em', height: '1.3em', marginTop: '9px', color: '#fff' }} /></RouterLink>
                            ) : (
                                <RouterLink to="/profile/bookmarks"><BookmarksIcon style={{ width: '1.3em', height: '1.3em', marginTop: '9px', color: '#fff' }} /></RouterLink>
                            )}
                        </div>
                        {userData.length === 0 ? (
                            <div className="cell vertical-middle text-center" style={{ width: '15%' }}>
                                <span className="cur-pointer" onClick={openModal}>
                                    <PersonIcon style={{ marginTop: '9px', marginRight: '9px', width: '1.4em', height: '1.4em' }} />
                                </span>
                            </div>
                        ) : (
                            <div className="cell vertical-middle text-center" style={{ width: '20%' }}>
                                <Avatar
                                    onClick={handleToggle2}
                                    ref={anchorRef2}
                                    aria-controls={
                                        open2 ? "menu-list-grow" : undefined
                                    }
                                    aria-haspopup="true"
                                    style={{ margin: '0px auto', cursor: 'pointer' }} alt="" src={userData.data.imageURL} />
                                <Popper
                                    open={open2}
                                    anchorEl={anchorRef2.current}
                                    role={undefined}
                                    style={{ marginTop: '10px' }}
                                    transition
                                    disablePortal>
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{
                                                transformOrigin:
                                                    placement === "bottom"
                                                        ? "center top"
                                                        : "center bottom",
                                            }}>
                                            <Paper>
                                                <ClickAwayListener onClickAway={handleClose2}>
                                                    <MenuList
                                                        autoFocusItem={open2}
                                                        id="menu-list-grow"
                                                        onKeyDown={handleListKeyDown2}>
                                                        <MenuItem onClick={handleClose2}>
                                                            <RouterLink to="/profile" style={{ fontSize: '0.920rem' }}>ویرایش اطلاعات کاربری</RouterLink>
                                                        </MenuItem>
                                                        <MenuItem style={{ fontSize: '0.920rem' }} onClick={handleDispatch}>خروج</MenuItem>
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </div>
                        )}
                    </div>
                    <Drawer
                        {...{
                            anchor: "right",
                            open: drawerOpen,
                            onClose: handleDrawerClose,
                            classes: { paper: drawerPaper, }
                        }}>
                        <div className={drawerContainer}>
                            <div className="menu-top-box" style={{ backgroundImage: `url('/images/home-page-header/menu-top.png')` }}>
                                <img src="/images/home-page-header/logo.png" className="menu-img " />
                                <h3 className="menu-h3">{staticText.mainTitle}</h3>
                            </div>
                            <p>&nbsp;</p>
                            {getDrawerChoices()}
                            <p className="menuLang">
                                <GTranslateIcon /> <span>{staticText.lang}</span>
                            </p>
                            <RadioGroup row aria-label="position" name="position" defaultValue={lang} style={{ marginRight: '40px' }}>
                                <FormControlLabel value="fa" color="#ffffff" control={<Radio color="success" />} label="فارسی" />
                                <FormControlLabel value="ar" color="#ffffff" control={<Radio color="success" />} label="عربی" />
                            </RadioGroup>
                            <Box mt={1} mr={3} textAlign="right">
                                <p style={{ marginTop: '0px', fontSize: '1rem' }}><a style={{ color: '#fff', fontSize: '0.9rem' }} target="_blank" href="https://www.asraweb.com/"><img style={{ height: '23px', position: 'relative', top: '5px' }} src="/images/asraweb-logo.png" /></a><span style={{ fontSize: '0.9rem', marginRight: '5px', color: '#fff' }}>(دپارتمان یکسو)</span></p>
                            </Box>
                        </div>
                    </Drawer>

                </Toolbar >
            </AppBar>
        );
    };

    const getDrawerChoices = () => {
        return headersData.map(({ label, href, icon }) => {
            return (
                <>
                    <Link
                        {...{
                            component: RouterLink,
                            to: href,
                            color: "inherit",
                            style: { textDecoration: "none" },
                            key: label,
                            className: "menuLink"
                        }}>
                        <MenuItem className="menuItem">
                            {icon === 'home' ? (
                                <HomeIcon />
                            ) : icon === 'products' ? (
                                <ListAltIcon />
                            ) : icon === 'articels' ? (
                                <MenuBookIcon />
                            ) : icon === 'about' ? (
                                <InfoIcon />
                            ) : (
                                <PhoneIcon />
                            )}
                            {label}</MenuItem>
                    </Link>
                </>
            );
        });
    };

    const getMenuButtons = () => {
        return headersData.map(({ label, href }) => {
            return (
                <Button
                    {...{
                        key: label,
                        color: "inherit",
                        to: href,
                        component: RouterLink,
                        className: menuButton,
                    }}
                >
                    {label}
                </Button>
            );
        });
    };

    const onClose = () => {
        setIsModalOpen(false);
    }

    return (
        <>
            {mobileView ? displayMobile() : displayDesktop()}
            <LoginModal open={isModalOpen} onClose={onClose} redirect={true} />
        </>
    );

}

Header.propTypes = {
    lang: PropTypes.string
}

export default Header
